import { Card, Label, List, Button, Icon, Table, TableHeader, TableHeaderCell, TableBody, TableRow, TableCell, ListItem, CardHeader, CardContent, CardDescription } from '@/components/bp/bp-ui';
import { SEARCH_TYPES_NAMES, type SearchCriteria } from './types';
import { BPButton } from '@/components/bp/bpbutton';

interface Props {
  criteria: SearchCriteria;
  index: number;
  onRemove: (id: string) => void;
  getTypeText?: (value: string) => string;
}

export const SearchCriteriaCard: React.FC<Props> = ({ criteria, index, onRemove, getTypeText }) => {
  const typeText = getTypeText ? getTypeText(criteria.searchType) : criteria.searchType;

  return (
    <Card>
      <CardContent>
        <CardHeader>
          {index > 0 && (
            <Label color={criteria.operator === 'AND' ? 'green' : criteria.operator === 'OR' ? 'blue' : 'red'} ribbon>
              {criteria.operator}
            </Label>
          )}
          {typeText}
        </CardHeader>
        {/* <Card.Meta>{criteria.searchType}</Card.Meta> */}
        <CardDescription>
          {criteria.searchType === SEARCH_TYPES_NAMES.DnaProfileSearchDto && 'markers' in criteria.params ? (
            <div>
              {'kitId' in criteria.params && (
                <div style={{ marginBottom: 10 }}>
                  <strong>Loci Order:</strong> {criteria.params.kitId}
                </div>
              )}
              <Table compact celled size="small">
                <TableHeader>
                  <TableRow><TableHeaderCell>Locus</TableHeaderCell><TableHeaderCell>Allele 1</TableHeaderCell><TableHeaderCell>Allele 2</TableHeaderCell></TableRow>
                </TableHeader>
                <TableBody>
                  {Object.entries(criteria.params.markers).filter(([_, a]) => a.allele1 || a.allele2).map(([locus, alleles]) => (
                    <TableRow key={locus}>
                      <TableCell><strong>{locus}</strong></TableCell>
                      <TableCell>{alleles.allele1 || '-'}</TableCell>
                      <TableCell>{alleles.allele2 || '-'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          ) : (
            <List>
              {Object.entries(criteria.params).filter(([_, v]) => v && _ != 'operator' && _ != 'discriminator').map(([k, v]) => (
                <ListItem key={k}><strong>{k}:</strong> {typeof v === 'object' ? JSON.stringify(v) : String(v)}</ListItem>
              ))}
            </List>
          )}
        </CardDescription>
      </CardContent>
      <CardContent extra>
        <BPButton basic color="red" size="tiny" onClick={() => onRemove(criteria.id)}>
          <Icon name="trash" /> Remove
        </BPButton>
      </CardContent>
    </Card>
  );
};